"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _SearchInput = _interopRequireDefault(require("../../screens/Settings/components/SearchInput"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["children", "keyword", "onChange", "noSearch", "className", "accountAvatar"];
var SearchInputHeader = function SearchInputHeader(_ref) {
  var children = _ref.children,
    keyword = _ref.keyword,
    onChange = _ref.onChange,
    _ref$noSearch = _ref.noSearch,
    noSearch = _ref$noSearch === void 0 ? false : _ref$noSearch,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$accountAvatar = _ref.accountAvatar,
    accountAvatar = _ref$accountAvatar === void 0 ? null : _ref$accountAvatar,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "flex pl-8 pr-5 py-5 items-center justify-between bg-app border-b z-10 flex-shrink-0"
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-4xl font-semibold text-gray-dark flex-grow"
  }, children), !noSearch && /*#__PURE__*/_react["default"].createElement(_SearchInput["default"], {
    value: keyword,
    onChange: onChange,
    autoFocus: true
  }), !!accountAvatar && /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-14 ml-4"
  }, accountAvatar));
};
var _default = exports["default"] = SearchInputHeader;
//# sourceMappingURL=index.js.map